import axios from '../axios'
import { formatSelectOption as format } from '@/utils'
const cache = {}
const getSelectData = () => {
  if (cache.select) return cache.select
  return (cache.select = axios.post('/gsgj/admin/droplist/projectSelect', null, { loading: 'gsgjselect' }).then(({ data = {} }) => {
    const { project = [], business = [] } = data.data || {}

    return {
      project: format(project, 'value'),
      business: format(business, 'value')
    }
  }, () => (cache.select = null)))
}

export const getProjectType = () => getSelectData().then(data => data.project)

export const getBusinessType = () => getSelectData().then(data => data.business)

export const getModuleList = system_id => axios.post('/gsgj/admin/droplist/moduleSelect', { system_id }, { loading: 'moduleselect' }).then(({ data = {} }) => format(data.data, 'value'))

/**
 * 战区列表
 * @param {number} business_type_id 业务类型id
 */
const loadDaquList = id =>
  axios.post('/bzmj/admin/dropDown/selectDaqu', { business_type_id: id }, { loading: 'daquselect' }).then(({ data }) => format(data.data, 'daqu_name'))
export const getDaquList = id => {
  if (id) return loadDaquList(id)
  return getBusinessType().then(data => {
    const { value } = data[0] || {}
    return loadDaquList(value)
  })
}

/**
 * 小区列表
 * @param {number} business_type_id 业务类型id
 * @param {number} daqu_id
 */
const loadXiaoquList = (id, daqu_id) =>
  axios
    .post('/bzmj/admin/dropDown/selectXiaoqu', { business_type_id: id, daqu_id }, { loading: 'xiaoquselect' })
    .then(({ data }) => format(data.data, 'xiaoqu_name'))
export const getXiaoquList = (id, daqu_id) => {
  if (!daqu_id) return Promise.resolve([])
  if (id) return loadXiaoquList(id, daqu_id)
  return getBusinessType().then(data => {
    const { value } = data[0] || {}
    return loadXiaoquList(value, daqu_id)
  })
}

/**
 * 门店列表
 * @param {number} id
 * @param {number} xiaoqu_id
 */
export const loadDealerList = (id, xiaoqu_id) =>
  axios
    .post('/bzmj/admin/dropDown/selectDealer', { business_type_id: id, xiaoqu_id }, { loading: 'dealerselect', cancel: 'select.dealer' })
    .then(({ data = {} }) => format(data.data, 'dealer_shortname'))
export const getDealerList = (id, xiaoqu_id) => {
  if (!xiaoqu_id) return Promise.resolve([])
  if (id) return loadDealerList(id, xiaoqu_id)
  return getBusinessType().then(data => {
    const { value } = data[0] || {}
    return loadDealerList(value, xiaoqu_id)
  })
}

export default {
  getProjectType,
  getBusinessType,
  getModuleList,
  getDaquList,
  getXiaoquList,
  getDealerList
}
